import { render, staticRenderFns } from "./PurchaseCostTotalCapture.vue?vue&type=template&id=660fe91c&scoped=true"
import script from "./PurchaseCostTotalCapture.vue?vue&type=script&lang=js"
export * from "./PurchaseCostTotalCapture.vue?vue&type=script&lang=js"
import "./PurchaseCostTotalCapture.vue?vue&type=style&index=0&id=660fe91c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660fe91c",
  null
  
)

export default component.exports